import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      isLoading: false,

      login: async (emailOrPhone, password) => {
        set({ isLoading: true });
        try {
          const { data } = await api.post('/auth/login', { emailOrPhone, password });
          set({
            user: data.user,
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
            isAuthenticated: true,
            isLoading: false,
          });
          api.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
          return { success: true, user: data.user };
        } catch (err) {
          set({ isLoading: false });
          const data = err.response?.data;
          return {
            success: false,
            error: data?.error || 'Erreur de connexion.',
            requiresEmailVerification: data?.requiresEmailVerification || false,
            email: data?.email || null,
          };
        }
      },

      // Déconnexion normale (bouton déconnexion)
      logout: async () => {
        const { refreshToken } = get();
        try { await api.post('/auth/logout', { refreshToken }); } catch {}
        get().forceLogout();
      },

      // Déconnexion forcée — vide tout sans appel API
      // Utilisée quand le token est invalide (base vidée, secret changé...)
      forceLogout: () => {
        delete api.defaults.headers.common['Authorization'];
        // Vider complètement le localStorage
        localStorage.removeItem('mecanobenin-auth');
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
          isLoading: false,
        });
        // Rediriger vers la page de connexion
        window.location.href = '/connexion';
      },

      updateUser: (updates) => set(state => ({ user: { ...state.user, ...updates } })),

      refreshAccessToken: async () => {
        const { refreshToken } = get();
        if (!refreshToken) {
          get().forceLogout();
          return false;
        }
        try {
          const { data } = await api.post('/auth/refresh', { refreshToken });
          set({ accessToken: data.accessToken, refreshToken: data.refreshToken });
          api.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
          return true;
        } catch {
          // Refresh token invalide → déconnexion forcée
          get().forceLogout();
          return false;
        }
      },

      // Vérifier au démarrage si le token est encore valide
      checkAuth: async () => {
        const { accessToken, isAuthenticated } = get();
        if (!isAuthenticated || !accessToken) return;
        try {
          await api.get('/auth/me');
        } catch (err) {
          if (err.response?.status === 401) {
            get().forceLogout();
          }
        }
      },
    }),
    {
      name: 'mecanobenin-auth',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
